import { SAVE_SETTINGS_REQUEST, SAVE_SETTINGS_FAILURE } from 'app/common/actions/settings/save'

import { SETTINGS_SUCCESS } from 'app/common/actions/settings/load'

import {
  IDENTIFIER_CARD,
  IDENTIFIER_KEYCHAIN,
  IDENTIFIER_KEYCHAIN_LEATHER,
  IDENTIFIER_BRACELET_SILICONE,
  IDENTIFIER_BRACELET_LEATHER,
  IDENTIFIER_BANK_CARD,
  IDENTIFIER_VIRTUAL_CARD,
  IDENTIFIER_SOMETHING,
  IDENTIFIER_RFID_TAG,
  IDENTIFIER_SBERBANK_CARD,
  IDENTIFIER_BRACELET_FITNESS,
  IDENTIFIER_SMART_WATCH,
  IDENTIFIER_BRACELET_KHAKI,
  IDENTIFIER_SMARTPHONE,
  IDENTIFIER_COBRAND_CARD,
  IDENTIFIER_USER_PHOTO,
  IDENTIFIER_SCHOOL_CARD,
  IDENTIFIER_SCHOOL_BRACELET,
} from 'app/common/constants/identifiers/types'

const defaultState = {
  [IDENTIFIER_CARD]: { blocked: true, withdrawn: true },
  [IDENTIFIER_KEYCHAIN]: { blocked: true, withdrawn: true },
  [IDENTIFIER_KEYCHAIN_LEATHER]: { blocked: true, withdrawn: true },
  [IDENTIFIER_BRACELET_SILICONE]: { blocked: true, withdrawn: true },
  [IDENTIFIER_BRACELET_LEATHER]: { blocked: true, withdrawn: true },
  [IDENTIFIER_BANK_CARD]: { blocked: true, withdrawn: true },
  [IDENTIFIER_VIRTUAL_CARD]: { blocked: true, withdrawn: true },
  [IDENTIFIER_SOMETHING]: { blocked: true, withdrawn: true },
  [IDENTIFIER_RFID_TAG]: { blocked: true, withdrawn: true },
  [IDENTIFIER_SBERBANK_CARD]: { blocked: true, withdrawn: true },
  [IDENTIFIER_BRACELET_FITNESS]: { blocked: true, withdrawn: true },
  [IDENTIFIER_SMART_WATCH]: { blocked: true, withdrawn: true },
  [IDENTIFIER_BRACELET_KHAKI]: { blocked: true, withdrawn: true },
  [IDENTIFIER_SMARTPHONE]: { blocked: true, withdrawn: true },
  [IDENTIFIER_COBRAND_CARD]: { blocked: true, withdrawn: true },
  [IDENTIFIER_USER_PHOTO]: { blocked: true, withdrawn: true },
  [IDENTIFIER_SCHOOL_CARD]: { blocked: true, withdrawn: true },
  [IDENTIFIER_SCHOOL_BRACELET]: { blocked: true, withdrawn: true },
}

export default function reducer(state = defaultState, action) {
  if (
    (action.type === SAVE_SETTINGS_REQUEST || action.type === SAVE_SETTINGS_FAILURE) &&
    action.payload.key &&
    action.payload.key === 'identifiers'
  ) {
    return { ...state, ...action.payload.obj }
  }
  if (action.type === SETTINGS_SUCCESS && action.payload.identifiers) {
    return { ...action.payload.identifiers }
  }

  return state
}
